import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import TituloAdmin from '@components/TituloAdmin';
import Boton from '@components/Boton';
import BotonIconoTabla from '@components/BotonIconoTabla';
import Label from '@components/Label';
import Input from '@components/Input';
import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorAdminStyle } from '@styles/cajaContenedorAdmin';
import { colors } from '@styles/colors';
import { selectStyle } from '@styles/selecsEstylos';
import '@styles/select2Custom.css';
import BoltIcon from '@mui/icons-material/Bolt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  buscarMiembrosWpApi,
  listarNivelesMiembrosWpApi,
  consultarEnviarDinamicaMiembroWpApi,
  listarBeneficiariosMiembroWpApi,
  listarCitasMiembroWpApi,
  registrarEnvioDinamicaExitosoMiembroWpApi,
} from '@api/wp/administracion/miembros/miembrosApi';
import Notify from '@components/Notify';
import LoadingOverlay from '@components/LoadingOverlay';
import '@styles/modernTable.css';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';

function Miembros() {
  const navigate = useNavigate();
  const [busquedaPersona, setBusquedaPersona] = useState('');
  const [estadoMembresia, setEstadoMembresia] = useState('');
  const [idNivelMembresia, setIdNivelMembresia] = useState('');
  const [nivelesPmpro, setNivelesPmpro] = useState([]);
  const [fechaInicioDesde, setFechaInicioDesde] = useState('');
  const [fechaInicioHasta, setFechaInicioHasta] = useState('');
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [buscado, setBuscado] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: '', type: 'success' });
  const [modalDinamicaOpen, setModalDinamicaOpen] = useState(false);
  const [filaDinamica, setFilaDinamica] = useState(null);
  const [enviandoDinamicaId, setEnviandoDinamicaId] = useState(null);
  const [resultadoDinamicaModal, setResultadoDinamicaModal] = useState({
    open: false,
    message: '',
    type: 'success',
  });
  const [modalBenefOpen, setModalBenefOpen] = useState(false);
  const [filaBenef, setFilaBenef] = useState(null);
  const [listaBeneficiarios, setListaBeneficiarios] = useState([]);
  const [cargandoBeneficiarios, setCargandoBeneficiarios] = useState(false);
  const [modalCitasOpen, setModalCitasOpen] = useState(false);
  const [filaCitas, setFilaCitas] = useState(null);
  const [listaCitas, setListaCitas] = useState([]);
  const [cargandoCitas, setCargandoCitas] = useState(false);

  const estadoMembresiaSelectRef = useRef(null);
  const nivelMembresiaSelectRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    if (!localStorage.getItem('token')) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const resp = await listarNivelesMiembrosWpApi();
        const lista = resp?.result || resp?.data || [];
        if (!cancelled) {
          setNivelesPmpro(Array.isArray(lista) ? lista : []);
        }
      } catch (e) {
        console.error('Error al cargar niveles PMPro:', e);
        if (!cancelled) {
          setNotification({
            open: true,
            message: 'No se pudieron cargar los niveles de membresía',
            type: 'error',
          });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  // Select2 — mismo criterio que CitasExtras.jsx
  useEffect(() => {
    try {
      const $ = window.$;
      if (!estadoMembresiaSelectRef.current || !$?.fn?.select2) {
        return undefined;
      }
      const $el = $(estadoMembresiaSelectRef.current);
      if ($el.hasClass('select2-hidden-accessible')) {
        $el.off('change.select2react');
        $el.select2('destroy');
      }
      $el.select2({
        placeholder: '-- Estado membresía --',
        allowClear: true,
        width: '100%',
        theme: 'default',
        minimumResultsForSearch: 0,
        language: {
          noResults: function () { return 'No se encontraron resultados'; },
          searching: function () { return 'Buscando...'; },
        },
      });
      $el.on('change.select2react', function () {
        setEstadoMembresia(String($el.val() || ''));
      });
      $el.val(estadoMembresia).trigger('change');
      return () => {
        if ($el.hasClass('select2-hidden-accessible')) {
          $el.off('change.select2react');
          $el.select2('destroy');
        }
      };
    } catch (e) {
      console.error('Error inicializando Select2 (estado membresía):', e);
      return undefined;
    }
  }, []);

  useEffect(() => {
    try {
      const $ = window.$;
      if (!nivelMembresiaSelectRef.current || !$?.fn?.select2) {
        return undefined;
      }
      const $el = $(nivelMembresiaSelectRef.current);
      if ($el.hasClass('select2-hidden-accessible')) {
        $el.off('change.select2react');
        $el.select2('destroy');
      }
      $el.select2({
        placeholder: '-- Todos los niveles --',
        allowClear: true,
        width: '100%',
        theme: 'default',
        minimumResultsForSearch: 0,
        language: {
          noResults: function () { return 'No se encontraron resultados'; },
          searching: function () { return 'Buscando...'; },
        },
      });
      $el.on('change.select2react', function () {
        setIdNivelMembresia(String($el.val() || ''));
      });
      $el.val(idNivelMembresia || '').trigger('change');
      return () => {
        if ($el.hasClass('select2-hidden-accessible')) {
          $el.off('change.select2react');
          $el.select2('destroy');
        }
      };
    } catch (e) {
      console.error('Error inicializando Select2 (nivel membresía):', e);
      return undefined;
    }
  }, [nivelesPmpro]);

  useEffect(() => {
    try {
      const $ = window.$;
      const el = estadoMembresiaSelectRef.current;
      if (!el || !$?.fn?.select2) return;
      const $el = $(el);
      if (!$el.hasClass('select2-hidden-accessible')) return;
      const v = estadoMembresia;
      if ($el.val() !== v) {
        $el.val(v || '').trigger('change');
      }
    } catch (_) {
      /* noop */
    }
  }, [estadoMembresia]);

  useEffect(() => {
    try {
      const $ = window.$;
      const el = nivelMembresiaSelectRef.current;
      if (!el || !$?.fn?.select2) return;
      const $el = $(el);
      if (!$el.hasClass('select2-hidden-accessible')) return;
      const v = idNivelMembresia;
      if ($el.val() !== v) {
        $el.val(v || '').trigger('change');
      }
    } catch (_) {
      /* noop */
    }
  }, [idNivelMembresia]);

  const handleCloseNotification = (event, reason) => {
    if (reason === 'clickaway') return;
    setNotification({ ...notification, open: false });
  };

  const handleBuscar = async () => {
    const tBusq = busquedaPersona.trim();
    const tEstadoMem = estadoMembresia.trim().toLowerCase();
    const tIdNivelMem = idNivelMembresia.trim();
    const tFecDesde = fechaInicioDesde.trim();
    const tFecHasta = fechaInicioHasta.trim();

    const hayTexto = !!tBusq;
    const hayMembresia = !!(
      tEstadoMem === 'active' ||
      tEstadoMem === 'inactive' ||
      tIdNivelMem ||
      tFecDesde ||
      tFecHasta
    );

    if (!hayTexto && !hayMembresia) {
      setNotification({
        open: true,
        message:
          'Indique al menos un criterio: texto de búsqueda y/o filtros de membresía',
        type: 'error',
      });
      return;
    }
    if (tFecDesde && tFecHasta && tFecDesde > tFecHasta) {
      setNotification({
        open: true,
        message: 'La fecha "desde" no puede ser posterior a la fecha "hasta"',
        type: 'error',
      });
      return;
    }
    try {
      setCargando(true);
      setBuscado(true);
      const payload = {
        busqueda_persona: tBusq,
        estado_membresia: tEstadoMem,
        fecha_inicio_desde: tFecDesde,
        fecha_inicio_hasta: tFecHasta,
      };
      if (tIdNivelMem) {
        payload.id_nivel_membresia = tIdNivelMem;
      }
      const resp = await buscarMiembrosWpApi(payload);
      const lista = resp?.result || resp?.data || [];
      setFilas(Array.isArray(lista) ? lista : []);
    } catch (err) {
      console.error('Error al buscar miembros:', err);
      setFilas([]);
      const msg = err?.message || err?.error || 'No se pudo completar la búsqueda';
      setNotification({ open: true, message: String(msg), type: 'error' });
    } finally {
      setCargando(false);
    }
  };

  const etiquetaEstado = (row) => {
    const raw = String(row?.status ?? '').trim();
    const active = raw.toLowerCase() === 'active';
    return { active, texto: active ? 'active' : raw || 'inactive' };
  };

  const abrirModalDinamica = (row) => {
    setFilaDinamica(row);
    setModalDinamicaOpen(true);
  };

  const cerrarModalDinamica = () => {
    setModalDinamicaOpen(false);
    setFilaDinamica(null);
  };

  const abrirModalBeneficiarios = async (row) => {
    const uid = row?.id;
    if (uid == null) return;
    setFilaBenef(row);
    setListaBeneficiarios([]);
    setModalBenefOpen(true);
    try {
      setCargandoBeneficiarios(true);
      const resp = await listarBeneficiariosMiembroWpApi(uid);
      const r = resp?.result ?? resp?.data ?? resp;
      const lista = r?.beneficiary_data ?? r?.beneficiarios ?? [];
      setListaBeneficiarios(Array.isArray(lista) ? lista : []);
    } catch (err) {
      console.error('Error al cargar beneficiarios:', err);
      setListaBeneficiarios([]);
      const msg = err?.message || err?.error || 'No se pudieron cargar los beneficiarios';
      setNotification({ open: true, message: String(msg), type: 'error' });
    } finally {
      setCargandoBeneficiarios(false);
    }
  };

  const cerrarModalBeneficiarios = () => {
    setModalBenefOpen(false);
    setFilaBenef(null);
    setListaBeneficiarios([]);
  };

  const abrirModalCitas = async (row) => {
    const uid = row?.id;
    if (uid == null) return;
    setFilaCitas(row);
    setListaCitas([]);
    setModalCitasOpen(true);
    try {
      setCargandoCitas(true);
      const resp = await listarCitasMiembroWpApi(uid);
      const r = resp?.result ?? resp?.data ?? resp;
      const lista = r?.citas ?? [];
      setListaCitas(Array.isArray(lista) ? lista : []);
    } catch (err) {
      console.error('Error al cargar citas:', err);
      setListaCitas([]);
      const msg = err?.message || err?.error || 'No se pudieron cargar las citas';
      setNotification({ open: true, message: String(msg), type: 'error' });
    } finally {
      setCargandoCitas(false);
    }
  };

  const cerrarModalCitas = () => {
    setModalCitasOpen(false);
    setFilaCitas(null);
    setListaCitas([]);
  };

  const confirmarEnvioDinamica = async () => {
    const uid = filaDinamica?.id;
    if (uid == null) {
      cerrarModalDinamica();
      return;
    }
    try {
      setEnviandoDinamicaId(uid);
      const resp = await consultarEnviarDinamicaMiembroWpApi(uid);
      const r = resp?.result ?? resp;
      const webhookUrl = String(r?.webhook_url ?? '').trim();
      const payload = r?.payload;
      const webhookHeaders = {
        'Content-Type': 'application/json',
        ...(r?.webhook_headers || {}),
      };

      if (!webhookUrl || !payload || typeof payload !== 'object') {
        throw new Error('No se recibió payload o URL del webhook desde backend');
      }

      const envioResp = await fetch(webhookUrl, {
        method: 'POST',
        headers: webhookHeaders,
        body: JSON.stringify(payload),
      });

      let detalle = '';
      try {
        detalle = await envioResp.text();
      } catch (e) {
        detalle = '';
      }

      const ok = envioResp.ok;
      if (ok) {
        try {
          await registrarEnvioDinamicaExitosoMiembroWpApi(uid);
          setFilas((prev) =>
            prev.map((f) =>
              f?.id === uid
                ? {
                    ...f,
                    dinamica_sent_count: Number(f?.dinamica_sent_count ?? 0) + 1,
                    dinamica_enviada: true,
                  }
                : f
            )
          );
        } catch (e) {
          console.error('No se pudo registrar el envío exitoso en DB:', e);
        }
      }
      setResultadoDinamicaModal({
        open: true,
        message: ok
          ? 'Enviado a Dinámica de forma correcta.'
          : `Error enviando a Dinámica (HTTP ${envioResp.status})${detalle ? `: ${detalle}` : ''}`,
        type: ok ? 'success' : 'error',
      });
      cerrarModalDinamica();
    } catch (err) {
      const msg = err?.message || err?.error || 'No se pudo enviar a Dinámica';
      setResultadoDinamicaModal({ open: true, message: String(msg), type: 'error' });
      cerrarModalDinamica();
    } finally {
      setEnviandoDinamicaId(null);
    }
  };

  const descargarExcel = () => {
    try {
      const headers = [
        'Correo',
        'Identificación',
        'Primer nombre',
        'Segundo nombre',
        'Primer apellido',
        'Segundo apellido',
        'Celular',
        'Nivel membresía',
        'Inicio membresía',
        'Estado',
      ];
      const rows = filas.map((item) => [
        item?.user_email ?? '',
        item?.id_number ?? '',
        item?.first_name ?? '',
        item?.second_name ?? '',
        item?.first_surname ?? '',
        item?.second_surname ?? '',
        item?.cellphone ?? '',
        item?.membership_level ?? '',
        item?.membership_start_date ?? '',
        etiquetaEstado(item).texto,
      ]);

      const sep = ';';
      const esc = (val) => {
        const s = String(val).replace(/"/g, '""');
        return `"${s}"`;
      };

      let contenido = '\uFEFF';
      contenido += headers.map(esc).join(sep) + '\r\n';
      for (const fila of rows) {
        contenido += fila.map(esc).join(sep) + '\r\n';
      }

      const blob = new Blob([contenido], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      const fecha = new Date().toISOString().slice(0, 10);
      a.href = url;
      a.download = `miembros_wp_${fecha}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error('Error al exportar CSV:', e);
      setNotification({ open: true, message: 'Error al exportar', type: 'error' });
    }
  };

  return (
    <div id="cajaPrincipal" style={cajaPrincipalStyle}>
      <TituloAdmin
        titulo="Miembros (WordPress)"
        imagen_titulo="servicios"
        subtitulo="Consulta de usuarios WP (texto y/o membresía: estado, nivel, rango de inicio). Máximo 1000 resultados."
      />

      <div style={cajaContenedorAdminStyle}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '2vh',
            alignItems: 'flex-end',
            marginBottom: '2vh',
          }}
        >
          <div>
            <Label>Búsqueda</Label>
            <Input
              placeholder="Identificación, nombres, apellidos, ciudad o correo..."
              value={busquedaPersona}
              onChange={(e) => setBusquedaPersona(e.target.value)}
              onIconClick={handleBuscar}
              ancho="min(38vh, 100%)"
              icono="buscar"
            />
          </div>
          <div style={{ minWidth: '22vh', flex: '0 1 22vh' }}>
            <Label>Estado membresía</Label>
            <select
              ref={estadoMembresiaSelectRef}
              value={estadoMembresia}
              onChange={(e) => setEstadoMembresia(e.target.value)}
              style={selectStyle}
              disabled={cargando}
            >
              <option value="">Todos</option>
              <option value="active">Activos</option>
              <option value="inactive">Inactivos</option>
            </select>
          </div>
          <div style={{ minWidth: 'min(40vh, 100%)', flex: '1 1 28vh' }}>
            <Label>Nivel de membresía</Label>
            <select
              ref={nivelMembresiaSelectRef}
              value={idNivelMembresia}
              onChange={(e) => setIdNivelMembresia(e.target.value)}
              style={selectStyle}
              disabled={cargando}
            >
              <option value="">-- Todos los niveles --</option>
              {nivelesPmpro.map((n) => (
                <option key={n.id} value={String(n.id)}>
                  {n.level_name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <Label>Inicio desde</Label>
            <Input
              type="date"
              value={fechaInicioDesde}
              onChange={(e) => setFechaInicioDesde(e.target.value)}
              ancho="20vh"
            />
          </div>
          <div>
            <Label>Inicio hasta</Label>
            <Input
              type="date"
              value={fechaInicioHasta}
              onChange={(e) => setFechaInicioHasta(e.target.value)}
              ancho="20vh"
            />
          </div>
          <Boton
            label={cargando ? 'Buscando...' : 'Consultar'}
            onClick={handleBuscar}
            disabled={cargando}
            color={colors.primary}
            ancho="18vh"
            alto="5vh"
          />
        </div>

        <div className="modern-table-container">
          <table id="tabla-miembros-wp" className="modern-table">
            <thead>
              <tr>
                <th>Correo</th>
                <th>Documento</th>
                <th>Nombres</th>
                <th>Apellidos</th>
                <th>Celular</th>
                <th>Nivel</th>
                <th>Inicio</th>
                <th>Final</th>
                <th>Estado</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {!buscado && (
                <tr>
                  <td colSpan={12} style={{ textAlign: 'center', padding: '3vh', color: colors.gray700 }}>
                    Indique criterios y pulse Consultar. Los datos no se cargan automáticamente.
                  </td>
                </tr>
              )}
              {buscado && filas.length === 0 && !cargando && (
                <tr>
                  <td colSpan={12} style={{ textAlign: 'center', padding: '3vh', color: colors.gray700 }}>
                    Sin resultados para los criterios indicados.
                  </td>
                </tr>
              )}
              {filas.map((row) => {
                const est = etiquetaEstado(row);
                const fechaInicio = String(row?.membership_start_date ?? '').trim();
                const fechaFinalRaw = String(row?.membership_end_date ?? '').trim();
                const fechaFinal = fechaFinalRaw && fechaFinalRaw !== fechaInicio ? fechaFinalRaw : '';
                const enviadoDinamica =
                  Number(row?.dinamica_sent_count ?? 0) > 0 || row?.dinamica_enviada === true;
                return (
                  <tr key={row.id}>
                    <td>{row.user_email ?? ''}</td>
                    <td>{row.id_number ?? ''}</td>
                    <td>
                      {[row.first_name, row.second_name].filter(Boolean).join(' ')}
                    </td>
                    <td>
                      {[row.first_surname, row.second_surname].filter(Boolean).join(' ')}
                    </td>
                    <td>{row.cellphone ?? ''}</td>
                    <td>{row.membership_level ?? ''}</td>
                    <td>{row.membership_start_date ?? ''}</td>
                    <td>{fechaFinal}</td>
                    <td>
                      <span
                        style={{
                          fontWeight: 600,
                          color: est.active ? colors.success : colors.errorText,
                        }}
                      >
                        {est.texto}
                      </span>
                    </td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <button
                        type="button"
                        title="Ver beneficiarios"
                        aria-label="Ver beneficiarios"
                        onClick={() => abrirModalBeneficiarios(row)}
                        disabled={cargandoBeneficiarios && filaBenef?.id === row.id}
                        style={{
                          width: '4.2vh',
                          height: '4.2vh',
                          borderRadius: '50%',
                          border: 'none',
                          backgroundColor:
                            cargandoBeneficiarios && filaBenef?.id === row.id
                              ? colors.gray400
                              : colors.primary,
                          color: colors.white,
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor:
                            cargandoBeneficiarios && filaBenef?.id === row.id
                              ? 'not-allowed'
                              : 'pointer',
                          padding: 0,
                        }}
                      >
                        <FamilyRestroomIcon style={{ fontSize: '2.4vh' }} />
                      </button>
                    </td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      {enviadoDinamica ? (
                        <CheckCircleIcon
                          titleAccess="Miembro ya enviado a Dinámica"
                          style={{ fontSize: '4.2vh', color: colors.success }}
                        />
                      ) : (
                        <button
                          type="button"
                          title="Enviar a Dinámica"
                          aria-label="Enviar a Dinámica"
                          onClick={() => abrirModalDinamica(row)}
                          disabled={enviandoDinamicaId === row.id}
                          style={{
                            width: '4.2vh',
                            height: '4.2vh',
                            borderRadius: '50%',
                            border: 'none',
                            backgroundColor:
                              enviandoDinamicaId === row.id ? colors.gray400 : colors.primary,
                            color: colors.white,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: enviandoDinamicaId === row.id ? 'not-allowed' : 'pointer',
                            padding: 0,
                          }}
                        >
                          <BoltIcon style={{ fontSize: '2.4vh' }} />
                        </button>
                      )}
                    </td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <BotonIconoTabla
                        icono="localHospital"
                        tooltipText="Ver citas médicas"
                        onClick={() => abrirModalCitas(row)}
                        disabled={cargandoCitas && filaCitas?.id === row.id}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div style={{ textAlign: 'right', marginTop: '1.5vh' }}>
          <Boton
            label="Descargar Excel"
            onClick={descargarExcel}
            disabled={cargando || filas.length === 0}
            color={colors.primary}
            ancho="25vh"
            alto="5vh"
          />
        </div>
      </div>

      {modalBenefOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '2vh',
              padding: '3vh',
              maxWidth: '95vw',
              width: 'min(110vh, 95vw)',
              maxHeight: '90vh',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              fontFamily: 'Inter',
            }}
          >
            <h2
              style={{
                color: colors.primaryText,
                fontSize: '2.2vh',
                fontWeight: 'bold',
                margin: 0,
                marginBottom: '1vh',
              }}
            >
              Beneficiarios del miembro
            </h2>
            <p style={{ color: colors.gray700, fontSize: '1.6vh', margin: '0 0 1.5vh 0' }}>
              {filaBenef?.user_email ?? ''}
              {filaBenef?.id_number ? ` · ${filaBenef.id_number}` : ''}
              {filaBenef?.id != null ? ` · user_id: ${filaBenef.id}` : ''}
            </p>
            {cargandoBeneficiarios ? (
              <p style={{ color: colors.gray700, textAlign: 'center', padding: '2vh' }}>
                Cargando…
              </p>
            ) : listaBeneficiarios.length === 0 ? (
              <p style={{ color: colors.gray700, textAlign: 'center', padding: '2vh' }}>
                Este titular no tiene beneficiarios registrados en el grupo de membresía.
              </p>
            ) : (
              <div style={{ overflow: 'auto', flex: 1, border: `1px solid ${colors.gray200}`, borderRadius: '1vh' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '1.5vh' }}>
                  <thead>
                    <tr style={{ backgroundColor: colors.gray200 }}>
                      <th style={{ textAlign: 'left', padding: '1vh' }}>ID WP</th>
                      <th style={{ textAlign: 'left', padding: '1vh' }}>Documento</th>
                      <th style={{ textAlign: 'left', padding: '1vh' }}>Nombres</th>
                      <th style={{ textAlign: 'left', padding: '1vh' }}>Apellidos</th>
                      <th style={{ textAlign: 'left', padding: '1vh' }}>Correo</th>
                      <th style={{ textAlign: 'left', padding: '1vh' }}>Celular</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listaBeneficiarios.map((b) => {
                      const nombres = b.full_name
                        ? String(b.full_name)
                        : [b.first_name, b.second_name].filter(Boolean).join(' ');
                      const apellidos = [b.first_surname, b.second_surname].filter(Boolean).join(' ');
                      return (
                        <tr key={b.id} style={{ borderBottom: `1px solid ${colors.gray200}` }}>
                          <td style={{ padding: '1vh' }}>{b.id ?? ''}</td>
                          <td style={{ padding: '1vh' }}>{b.id_number ?? b.numero_documento ?? ''}</td>
                          <td style={{ padding: '1vh' }}>{nombres}</td>
                          <td style={{ padding: '1vh' }}>{apellidos}</td>
                          <td style={{ padding: '1vh' }}>{b.user_email ?? b.beneficiary_email ?? ''}</td>
                          <td style={{ padding: '1vh' }}>{b.beneficiary_cellphone ?? ''}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2vh' }}>
              <Boton
                label="Cerrar"
                onClick={cargandoBeneficiarios ? undefined : cerrarModalBeneficiarios}
                disabled={cargandoBeneficiarios}
                color={colors.primary}
              />
            </div>
          </div>
        </div>
      )}

      {modalCitasOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '2vh',
              padding: '3vh',
              maxWidth: '95vw',
              width: 'min(120vh, 95vw)',
              maxHeight: '90vh',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              fontFamily: 'Inter',
            }}
          >
            <h2
              style={{
                color: colors.primaryText,
                fontSize: '2.2vh',
                fontWeight: 'bold',
                margin: 0,
                marginBottom: '1vh',
              }}
            >
              Citas médicas del miembro
            </h2>
            <p style={{ color: colors.gray700, fontSize: '1.6vh', margin: '0 0 1.5vh 0' }}>
              {filaCitas?.user_email ?? ''}
              {filaCitas?.id_number ? ` · ${filaCitas.id_number}` : ''}
              {filaCitas?.id != null ? ` · user_id: ${filaCitas.id}` : ''}
            </p>
            {cargandoCitas ? (
              <p style={{ color: colors.gray700, textAlign: 'center', padding: '2vh' }}>
                Cargando…
              </p>
            ) : listaCitas.length === 0 ? (
              <p style={{ color: colors.gray700, textAlign: 'center', padding: '2vh' }}>
                No hay citas registradas para este paciente (id_paciente).
              </p>
            ) : (
              <div style={{ overflow: 'auto', flex: 1, border: `1px solid ${colors.gray200}`, borderRadius: '1vh' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '1.45vh' }}>
                  <thead>
                    <tr style={{ backgroundColor: colors.gray200 }}>
                      <th style={{ textAlign: 'left', padding: '0.9vh' }}>Id cita</th>
                      <th style={{ textAlign: 'left', padding: '0.9vh' }}>Fecha</th>
                      <th style={{ textAlign: 'left', padding: '0.9vh' }}>Método</th>
                      <th style={{ textAlign: 'left', padding: '0.9vh' }}>Valor</th>
                      <th style={{ textAlign: 'left', padding: '0.9vh' }}>Cita</th>
                      <th style={{ textAlign: 'left', padding: '0.9vh' }}>Estado pago</th>
                      <th style={{ textAlign: 'left', padding: '0.9vh' }}>Order id</th>
                      <th style={{ textAlign: 'left', padding: '0.9vh' }}>Fecha registro</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listaCitas.map((c) => {
                      const idKey = c.appointment_id ?? c.id;
                      const fecha = c.appointment_date ?? c.fecha;
                      const metodo = c.method ?? c.metodo;
                      const valor = c.amount ?? c.valor;
                      const estadoCita = c.appointment_status ?? c.cita;
                      const estadoPago = c.payment_status ?? c.estado;
                      const registro = c.bold_created_at ?? c.fechaSis;
                      return (
                        <tr key={idKey} style={{ borderBottom: `1px solid ${colors.gray200}` }}>
                          <td style={{ padding: '0.9vh' }}>{idKey ?? ''}</td>
                          <td style={{ padding: '0.9vh' }}>{fecha != null ? String(fecha) : ''}</td>
                          <td style={{ padding: '0.9vh' }}>{metodo ?? ''}</td>
                          <td style={{ padding: '0.9vh' }}>{valor != null ? String(valor) : ''}</td>
                          <td style={{ padding: '0.9vh' }}>{estadoCita ?? ''}</td>
                          <td style={{ padding: '0.9vh' }}>{estadoPago ?? ''}</td>
                          <td style={{ padding: '0.9vh' }}>{c.order_id ?? ''}</td>
                          <td style={{ padding: '0.9vh' }}>
                            {registro != null ? String(registro) : ''}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2vh' }}>
              <Boton
                label="Cerrar"
                onClick={cargandoCitas ? undefined : cerrarModalCitas}
                disabled={cargandoCitas}
                color={colors.primary}
              />
            </div>
          </div>
        </div>
      )}

      {modalDinamicaOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '2vh',
              padding: '4vh',
              maxWidth: '80vh',
              width: '90%',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              textAlign: 'center',
              fontFamily: 'Inter',
            }}
          >
            <h2
              style={{
                color: colors.primaryText,
                fontSize: '2.4vh',
                fontWeight: 'bold',
                marginBottom: '2vh',
                margin: 0,
              }}
            >
              ¿Confirma el envío de este miembro a Dinámica?
            </h2>
            <p style={{ color: colors.gray700, fontSize: '1.8vh', marginTop: '1.5vh' }}>
              {filaDinamica?.user_email ?? ''}
              {filaDinamica?.id_number ? ` · ${filaDinamica.id_number}` : ''}
            </p>
            <div style={{ display: 'flex', gap: '2vh', justifyContent: 'center', marginTop: '3vh' }}>
              <Boton
                label={enviandoDinamicaId != null ? 'Enviando...' : 'Sí, enviar'}
                onClick={enviandoDinamicaId != null ? undefined : confirmarEnvioDinamica}
                disabled={enviandoDinamicaId != null}
                color={colors.primary}
              />
              <Boton
                label="No, cancelar"
                onClick={enviandoDinamicaId != null ? undefined : cerrarModalDinamica}
                disabled={enviandoDinamicaId != null}
                color={colors.gray600}
              />
            </div>
          </div>
        </div>
      )}

      {resultadoDinamicaModal.open && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1001,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '2vh',
              padding: '4vh',
              maxWidth: '80vh',
              width: '90%',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              textAlign: 'center',
              fontFamily: 'Inter',
            }}
          >
            <h2
              style={{
                color: resultadoDinamicaModal.type === 'success' ? colors.success : colors.errorText,
                fontSize: '2.4vh',
                fontWeight: 'bold',
                marginBottom: '2vh',
                margin: 0,
              }}
            >
              {resultadoDinamicaModal.type === 'success' ? 'Envío exitoso' : 'Error en envío'}
            </h2>
            <p style={{ color: colors.gray700, fontSize: '1.8vh', marginTop: '1.5vh' }}>
              {resultadoDinamicaModal.message}
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '3vh' }}>
              <Boton
                label="Aceptar"
                onClick={() => setResultadoDinamicaModal({ open: false, message: '', type: 'success' })}
                color={colors.primary}
              />
            </div>
          </div>
        </div>
      )}

      <Notify
        open={notification.open}
        message={notification.message}
        type={notification.type}
        onClose={handleCloseNotification}
      />
      <LoadingOverlay visible={cargando} />
    </div>
  );
}

export default Miembros;
